<template>
  <b-overlay :show="loading" opacity="0.99">
    <b-modal
      id="finance_configuration_category"
      title="ALTERAR CATEGORIA DO FINANCEIRO"
      no-close-on-backdrop
      hide-footer
    >
      <finance-configuration-category
        :category_id="category_id"
        :service_id="item.id"
        :finance_configuration_category="finance_configuration_category"
        @success="handleSuccessFinanceConfigurationCategory"
      />
    </b-modal>
    <form @submit.prevent="update" method="post">
      <div class="row">
        <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
          <LabelRequiredField label="Tipo de cobrança" />
          <select
            :disabled="!permission('edit', 'service')"
            v-model="service_charge_type_id"
            class="form-control"
          >
            <option value>SELECIONE...</option>
            <option
              v-for="value in serviceChargeTypes"
              :key="value.id"
              :value="value.id"
            >
              {{ String(value.name).toUpperCase() }}
            </option>
          </select>
        </div>

        <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 col-12">
          <LabelRequiredField label="Descrição" />
          <input
            :disabled="!permission('edit', 'service')"
            type="text"
            ref="autofocus"
            v-model="description"
            class="form-control"
          />
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
          <LabelRequiredField label="Custo do serviço" />
          <input
            :disabled="!permission('edit', 'service')"
            type="text"
            v-model="service_cost"
            class="form-control"
            v-on:keyup="handleValueServiceCost"
          />
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
          <label>Lucro(%)</label>
          <input
            :disabled="!permission('edit', 'service')"
            type="text"
            v-on:keyup="handleValueProfit"
            v-model="profit"
            class="form-control"
          />
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
          <LabelRequiredField label="Valor da venda" />
          <input
            :disabled="!permission('edit', 'service')"
            type="text"
            v-model="sale_price"
            class="form-control"
            v-on:keyup="handleValueSalePrice"
          />
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <h6 class="mb-0 worksansr">
            Criação:
            {{ formatDate(item.created_at) }}
          </h6>
          <h6 class="mb-0 worksansr">
            Última alteração:
            {{ formatDate(item.updated_at) }}
          </h6>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <WarningMessage
            v-if="!permission('edit', 'service')"
            message="Você não tem permissão para modificar serviços"
          />
          <WarningRequiredFields v-if="permission('edit', 'service')" />
          <ErrorsMessages :errors="errors" />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 text-left">
          <confirmation-dialog
            v-if="permission('remove', 'service')"
            :disabled="loading"
            message-title="Confirmar"
            message-body="Deseja realmente apagar o serviço?"
            open-text="EXCLUIR"
            open-class="btn-delete mr-2"
            open-left-icon="fa-trash mr-2"
            @yes="handleDelete"
          />
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 text-right">
          <v-btn
            v-if="permission('edit', 'service')"
            :disabled="loading"
            type="submit"
            class="btn-save m-1"
          >
            <i class="fas fa-save mr-2 text-twenty"></i>
            {{ loading ? "Carregando" : "SALVAR" }}
          </v-btn>
        </div>
        <div class="col-md-12 pb-0" v-if="permission('read', 'financial')">
          <label>CATEGORIA DO FINANCEIRO</label>
          <div class="input-group">
            <b-input
              disabled
              :value="
                item.finance_configuration_category_name
                  ? item.finance_configuration_category_name
                  : 'NÃO INFORMADO'
              "
            />
            <div class="input-group-pprend">
              <v-btn @click="handleModalFinance" class="btn-i btn-block">
                <i class="fas fa-edit mr-2 text-twenty"></i>
                ALTERAR CATEGORIA DO FINANCEIRO
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </form>
  </b-overlay>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";
import LabelRequiredField from "../Components/LabelRequiredField";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import ConfirmationDialog from "../Components/ConfirmationDialog";

import FinanceConfigurationCategory from "./finance-configuration-category.vue";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import {
  formatDate,
  formatPrice,
  formatValueOnKeyUp,
  formatValueToOnlyNumber,
  formatValueToPercentage,
} from "../../lib/format";

import permission from "../../lib/permission";

export default {
  name: "Edit",

  components: {
    ErrorsMessages,
    LabelRequiredField,
    WarningRequiredFields,
    ConfirmationDialog,
    FinanceConfigurationCategory,
  },

  props: {
    item: { type: Object },
    serviceChargeTypes: { type: Array },
    finance_configuration_category: { type: Array },
  },

  data() {
    return {
      id: "",
      service_charge_type_id: "",
      description: "",
      service_cost: "",
      profit: "",
      sale_price: "",
      category_id: "",
      loading: false,
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,
    formatDate,
    formatPrice,
    formatValueOnKeyUp,
    formatValueToOnlyNumber,
    formatValueToPercentage,

    handleSuccessFinanceConfigurationCategory() {
      this.update();
      // this.$bvModal.hide(`edit_${String(this.id)}`);
      // this.$emit("success");
    },

    handleModalFinance() {
      let { item } = this;
      this.category_id = item.finance_configuration_category_id;
      this.$bvModal.show("finance_configuration_category");
    },

    handleValueProfit: function (e) {
      let profit = formatValueToPercentage(e.target.value);
      if (profit) {
        let current = formatValueToOnlyNumber(this.service_cost);
        let percentage = profit * current;
        let sale_price = percentage / 100;
        sale_price = parseFloat(sale_price) + parseFloat(current);
        this.sale_price = formatPrice(sale_price);
      } else {
        this.sale_price = formatPrice(0);
      }
    },

    handleValueServiceCost: function (e) {
      this.service_cost = formatValueOnKeyUp(e.target.value);

      let { profit, service_cost } = this;

      if (profit) {
        let current = formatValueToOnlyNumber(service_cost);
        let percentage = profit * current;
        let sale_price = percentage / 100;
        sale_price = parseFloat(sale_price) + parseFloat(current);
        this.sale_price = formatPrice(sale_price);
      } else {
        this.sale_price = formatPrice(0);
      }
    },

    handleValueSalePrice: function (e) {
      let sale_price = formatValueToOnlyNumber(e.target.value);

      this.sale_price = formatValueOnKeyUp(sale_price);

      let { service_cost } = this;

      service_cost = formatValueToOnlyNumber(service_cost);

      if (parseFloat(sale_price) > parseFloat(service_cost)) {
        let profit = parseFloat(sale_price) - parseFloat(service_cost);
        profit = parseFloat(profit) / parseFloat(service_cost);
        profit = parseFloat(profit) * 100;
        if (String(profit).indexOf(".") > -1) {
          profit = profit.toFixed(2);
        }
        this.profit = profit;
      } else {
        this.profit = 0;
      }
    },

    async retrieve() {
      this.id = this.item.id;
      this.service_charge_type_id = this.item.service_charge_type_id;
      this.description = this.item.description;
      this.handleValueServiceCost({
        target: {
          value: this.item.service_cost ? String(this.item.service_cost) : "",
        },
      });
      this.handleValueProfit({
        target: { value: this.item.profit ? String(this.item.profit) : "" },
      });
      this.handleValueSalePrice({
        target: {
          value: this.item.sale_price ? String(this.item.sale_price) : "",
        },
      });
      this.profit = this.item.profit;
      this.errors = [];
      setTimeout(() => this.$refs.autofocus.focus(), 10);
    },

    async update() {
      try {
        this.loading = true;

        const {
          id,
          service_charge_type_id,
          description,
          service_cost,
          profit,
          sale_price,
        } = this;

        let params = {
          id,
          service_charge_type_id,
          description,
          service_cost,
          profit,
          sale_price,
        };

        const response = await api.put("/rest-home/service/update", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(`edit_${String(id)}`);
          toast(message, "success");
          this.$emit("success");
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async handleDelete() {
      try {
        const { id } = this;

        let data = { id };

        const response = await api.delete("/rest-home/service/delete", {
          data,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.$emit("success");
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
</style>